import { StoreActionApi } from 'react-sweet-state';

import { ensureQuizProgressExists, LearningProgressStatus } from 'src/services/http/progress';
import { ContentfulSmLesson } from 'src/graphql/queries/GetSmLesson';
import { ContentfulSmCourse } from 'src/graphql/queries/GetSmCourse';
import { User } from 'src/types';
import { ProgressState } from 'src/store/progress/progressStore';
import {
  completeLessonAsync,
  updateLearningPathProgressUponLessonCompletion,
  updateProgressUponLessonCompletion,
} from 'src/store/progress/utils/progressUtils';
import { isStandalone } from 'src/pages/LessonPage/utils/isStandalone';

export const fetchQuizProgress =
  (lesson: ContentfulSmLesson, course: ContentfulSmCourse | undefined, user: User | null | undefined) =>
  async ({ getState, dispatch }: StoreActionApi<ProgressState>): Promise<void> => {
    const { progressForLessons } = getState();

    if (!user || !lesson.quiz) {
      return;
    }

    const lessonProgress = progressForLessons?.lessons.find((p) => p.lessonId === lesson.sys.id);

    if (lessonProgress?.status === LearningProgressStatus.COMPLETED) {
      return;
    }

    const quizSection = lessonProgress?.section?.find((s) => s.sectionId === 'quiz');

    if (quizSection?.status === LearningProgressStatus.COMPLETED) {
      return;
    }

    const quizProgress = await ensureQuizProgressExists(lesson.sys.id, lesson.quiz.sys.id);

    if (!quizProgress || quizProgress.status !== LearningProgressStatus.COMPLETED) {
      return;
    }

    await dispatch(completeLesson(lesson, course, user));
  };

export const completeLesson =
  (lesson: ContentfulSmLesson, course: ContentfulSmCourse | undefined, user: User | null | undefined) =>
  async ({ setState, getState }: StoreActionApi<ProgressState>): Promise<void> => {
    const { progressForLessons, progressForCourses, isLoadingProgressForCourses } = getState();

    if (progressForLessons) {
      const updatedProgress = await completeLessonAsync(user, lesson, progressForLessons);

      const updatedLessonProgress = updateProgressUponLessonCompletion(course, lesson, updatedProgress);

      setState({
        progressForLessons: updatedLessonProgress,
      });

      if (!isLoadingProgressForCourses && course && !isStandalone()) {
        setState({
          progressForCourses: updateLearningPathProgressUponLessonCompletion(
            course,
            updatedLessonProgress,
            progressForCourses,
          ),
        });
      }
    }
  };
